import React, { FC } from 'react';

import { Box, Paper, Text, Title } from '@mantine/core';

import cx from './Banner.module.scss';

const Banner: FC<{
    logo: React.ReactNode;
    title: string;
    description: string;
    actions: React.ReactNode;
}> = ({ logo, title, description, actions }) => (
    <Paper p={{ base: 'lg', lg: 'xl' }} shadow="md" radius="md">
        <Box className={cx.logo}>{logo}</Box>
        <Box className={cx.content}>
            <Title className={cx.title}>{title}</Title>
            <Text className={cx.description}>{description}</Text>
            <Box className={cx.actions}>{actions}</Box>
        </Box>
    </Paper>
);

export { Banner };
